import { Goal, UsersRound } from "lucide-react"

interface StadiumFactsProps {
  sports?: string[]
  teams?: string[]
}

export function StadiumFacts({ sports = [], teams = [] }: StadiumFactsProps) {
  if (sports.length === 0 && teams.length === 0) return null

  const facts = [
    sports.length > 0
      ? {
          label: "Sport",
          value: sports[0],
          icon: Goal,
        }
      : null,
    teams.length > 0
      ? {
          label: "Home club",
          value: teams[0],
          icon: UsersRound,
        }
      : null,
  ].filter((fact): fact is NonNullable<typeof fact> => fact !== null)

  return (
    <div
      className={`mx-auto mb-4 grid w-fit max-w-full overflow-hidden rounded-xl border border-white/20 bg-black/70 text-left shadow-[0_12px_32px_rgba(0,0,0,0.24)] backdrop-blur-xl ${
        facts.length > 1 ? "grid-cols-2" : "grid-cols-1"
      }`}
    >
      {facts.map((fact, index) => {
        const Icon = fact.icon
        return (
          <div
            key={fact.label}
            className={`flex min-w-0 items-center gap-2.5 px-3.5 py-2.5 md:min-w-48 md:px-4 ${
              index > 0 ? "border-l border-white/15" : ""
            }`}
          >
            <Icon className="size-4 shrink-0 text-[#ff8b7d]" aria-hidden="true" />
            <span className="min-w-0">
              <span className="block text-[10px] font-semibold text-white/65">
                {fact.label}
              </span>
              <strong className="block max-w-44 truncate text-sm font-extrabold text-white md:max-w-48">
                {fact.value}
              </strong>
            </span>
          </div>
        )
      })}
    </div>
  )
}
